import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'abbreviatedNumber'
})
export class AbbreviatedNumberPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    if(value>999 && value<1000000){
      value = (value/1000).toFixed(1);
      value = value+' '+'K';
    }
    if(value>999999 && value<1000000000){
      value = (value/1000000).toFixed(1);
      value = value+' '+'M';
    }
    if(value>999999999 && value<1000000000000){
      value = (value/1000000000).toFixed(1);
      value = value+' '+'B';
    }
    if(value>999999999999){
      value = (value/1000000000000).toFixed(1);
      value = value+' '+'T';
    }
    return value;
  }

}
